"use client";

// import CarouselWrapper from "@/blocks/Sliders/CarouselWrapper";
// import EventCard from "../EventCard";
import dynamic from "next/dynamic";

const GeneralListing = dynamic(()=> import("./GeneralListing"), { ssr: false });

interface GenaralListingSectionProps {
  id?: string;
  no_of_columns?: number;
  arrayList?: any;
  domain?: string;
  displayView?: string;
  carouselAutoplay?: boolean;
  carouseltransition?: string;
  slidesToShow?: number;
  slidesToScroll?: number;
  autoplaySpeed?: number; 
  speed?: number;
  centerMode?:boolean; 
  showButtons?: boolean; 
  showPaging?: boolean; 
  infinite?:boolean; 
  pauseOnHover?:boolean; 
  swipeToSlide?: boolean; 
  draggable?: boolean; 
  variableWidth?: boolean;
  maxCardWidth?: number;
  buttonText?: string;
  datePrefix?: string;
}

const GeneralListingComp = ({ id, ...props }: GenaralListingSectionProps) => {
  
  return (
    <>
      <GeneralListing id={id} {...props}/>
    </>
  );
};

export default GeneralListingComp;
